import React from "react";
import { Link } from "react-router-dom";

import "./card.css";

import linkIcon from "../../../assets/img/Link.png";

function Card({ title, children, to, bodyClassName = "" }) {
  return (
    <div className="card-container">
      {title && (
        <div className="card-header">
          <h3>{title}</h3>

          {to ? (
            <Link
              to={to}
              className="card-btn"
              aria-label={`${title} 바로가기`}
            >
              <img src={linkIcon} alt={`${title} 바로가기 아이콘`} />
            </Link>
          ) : (
            <button
              type="button"
              className="card-btn"
              aria-label={`${title} 바로가기`}
            >
              <img src={linkIcon} alt={`${title} 바로가기 아이콘`} />
            </button>
          )}
        </div>
      )}

      <div className={`card-body ${bodyClassName}`}>
        {children}
      </div>
    </div>
  );
}

export default React.memo(Card);